<template>
  <section class="notifications">
    <section-title>Notifications Component</section-title>
    <form-wrap>
      <form-field-set>
        <text-input
          v-model="message"
          :direction="direction"
          label="Notification Message"
          name="message"
        />
        <select-input
          v-model="type"
          :direction="direction"
          :options="types"
          label="Notification Types"
          name="notification-types"
        />

        <button-input @click="handleAddNotification">
          Add Notification
        </button-input>
      </form-field-set>
    </form-wrap>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import { NOTIFICATION_TYPES } from '@/store/modules/notifications/types'
import PlaygroundCommmonMixin from '@/mixins/pages/playground/PlaygroundCommon'
import ButtonInput from '@/components/ui/ButtonInput'
import SelectInput from '@/components/forms/SelectInput'
import FormFieldSet from '@/components/forms/FormFieldSet'
import FormWrap from '@/components/forms/FormWrap'
import RadioBarInput from '@/components/forms/RadioBarInput'
import SectionTitle from '@/components/ui/SectionTitle'
import TextInput from '@/components/forms/TextInput'

export default {
  name: 'RadioBarInputs',
  mixins: [PlaygroundCommmonMixin],
  components: {
    ButtonInput,
    FormFieldSet,
    FormWrap,
    RadioBarInput,
    SectionTitle,
    SelectInput,
    TextInput
  },
  data () {
    return {
      message: 'This is a custom message',
      type: 'NOTIFICATION_TYPE_SUCCESS'
    }
  },
  computed: {
    types () {
      return NOTIFICATION_TYPES.map(t => ({ label: t, value: t }))
    }
  },
  methods: {
    ...mapActions([
      'addNotification'
    ]),
    handleAddNotification () {
      const { message, type } = this
      this.addNotification({ message, type, duration: 5000 })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/playground/Notifications.vue